<template>
  <BaseCenteredModal
    v-model:is-modal-open="localIsModalOpen"
    :title="sendTitle"
    size="large"
  >
    <template #body>
      <div class="grid w-full grid-cols-2 gap-5 pt-2">
        <div>
          <BaseSelectMultiple
            v-if="metadata.users"
            :label="$t('attributes.receivers')"
            :placeholder="$t('attributes.receivers')"
            name="receivers"
            :options="metadata.users || []"
            attributeLabel="name"
            :searchable="true"
            :defaultValue="cDefautlValue"
            @setSelected="getInputValue"
            :disabled="permissions"
          />
        </div>
        <div>
          <BaseInput
            :label="$t('attributes.subject')"
            :placeholder="$t('attributes.subject')"
            v-model="info.subject"
            :disabled="permissions"
          />
        </div>
        <div class="col-span-2">
          <BaseSelectSimple
            v-if="metadata.message_texts"
            :key="metadata.message_texts.id"
            :label="$t('global.message_text')"
            :placeholder="$t('global.message_text')"
            name="messageConverted"
            :options="metadata.message_texts"
            :required="false"
            @setSelected="getInputValue"
          />
        </div>
        <div class="col-span-2">
          <!--              :key="info.messageConverted"-->
          <BaseWysiwyg
            v-model="info.messageConverted"
            :value="info.messageConverted"
            ref="editorForm"
            name="message"
          />
        </div>
      </div>
    </template>
    <template #footer>
      <BaseButton
        :title="$t('button.send')"
        icon="paper-plane"
        color="primary"
        @click="submitForm"
      />
      <BaseButton :title="$t('button.close')" color="dark" @click="close" />
    </template>
  </BaseCenteredModal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import BaseCenteredModal from '@c/addf-package/components/modal/BaseCenteredModal.vue'
export default {
  name: 'InvoicingSendDialog',
  components: { BaseCenteredModal },
  emits: ['close', 'backdropClicked'],
  props: {
    isModalVisible: {
      type: Boolean,
      required: true
    }
  },

  computed: {
    ...mapGetters({
      invoice: 'invoicing/getInvoice',
      metadata: 'invoicing/getInvoiceMetadata',
      info: 'invoicing/getSendInvoiceData'
    }),
    localIsModalOpen: {
      get() {
        return this.isModalVisible
      },
      set(value) {
        if (!value) this.close()
      }
    },
    permissions() {
      return !this.$can('manage_invoicing')
    },
    sendTitle() {
      const { work, reference } = this.invoice ?? {}
      return work ? `${work.title} (${reference})` : reference
    },
    cDefautlValue() {
      let customer_users = this.metadata.users.filter((user) =>
        this.invoice.customer.users?.map((item) => item.id).includes(user.id)
      )
      if (customer_users.length) {
        this.info.receivers = customer_users
      }
      return customer_users
    }
  },
  methods: {
    ...mapActions({
      sendInvoice: 'invoicing/sendInvoice',
      getMessageConverted: 'invoicing/fetchSendInvoiceMessageTextConverted'
    }),
    getInputValue({ attribute, value }) {
      console.log('ok', attribute)
      this.info[attribute] = value
      if (attribute === 'messageConverted') {
        this.getMessageConverted({
          model: 'invoice',
          model_id: this.invoice.id,
          messageText_id: value
        })
      }
    },
    submitForm() {
      if (
        this.info.receivers &&
        this.info.subject &&
        this.info.messageConverted
      ) {
        this.sendInvoice({
          info: {
            invoice_id: this.invoice.id,
            doc_type: this.invoice.doc_type,
            subject: this.info.subject,
            receivers: this.info.receivers,
            message: this.info.messageConverted
          }
        }).then(() => {
          this.$h.toastSuccess(this.$t('global.send_message_success'))
          this.close()
          this.info.receivers = null
          this.info.subject = null
          this.info.messageConverted = null
        })
      } else {
        this.$h.toastWarning(this.$t('toasts.send_invoice_fields_required'))
      }
    },
    close() {
      this.$emit('close')
    }
  }
}
</script>
